import blockchainBlog from '../assets/blogs/blockchain-blog.svg'
import ethTodoBlog from '../assets/blogs/eth-todo-blog.svg'
import recoilBlog from '../assets/blogs/recoil-blog.svg'
export const blogsData = [
  {
    id: 1,
    title: 'recoil-js (A much simpler state management library)',
    image: recoilBlog,
    tags: ['recoiljs', 'state mangement'],
    link: 'https://tarun-s.medium.com/recoil-js-a-much-simpler-state-management-library-de3bc4f021e2'
  },

  {
    id: 2,
    title: 'Blockchain, and state of Blockchain at early 2021.',
    image: blockchainBlog,
    tags: ['Blockchain', 'DLT', 'Blockchain Adpotion'],
    link: 'https://tarun-s.medium.com/blockchain-and-state-of-blockchain-at-early-2021-44f3f2cb0017'
  },

  {
    id: 3,
    title: 'Creating a todo app on blockchain using Ethereum,web3 & hooks.',
    image: ethTodoBlog,
    tags: ['Blockchain', 'Ethereum', 'Truffle'],
    link: 'https://tarun-s.medium.com/a-todo-app-on-a-blockchain-using-ethereum-using-react-and-hooks-f4a751c40793'
  }
]
